import { Text } from "@mantine/core";
import type { FC } from "react";
import { TrainingSessionChallengeResultStatus } from "../types";
import { getChallengeResults } from "../utils";

const CHALLENGE_EVALUATION_TITLE = {
    [TrainingSessionChallengeResultStatus.CLEARED]: "You passed! ✅ ",
    [TrainingSessionChallengeResultStatus.NOT_CLEARED]: "You didn’t pass this time. 😔",
    [TrainingSessionChallengeResultStatus.NOT_AVAILABLE]: "Feedback not available.",
    [TrainingSessionChallengeResultStatus.ERROR]: "Call duration too short - feedback not available. ⚠️",
    [TrainingSessionChallengeResultStatus.PROCESSING]: "Evaluations Results Processing",
} satisfies Record<TrainingSessionChallengeResultStatus, string>;

export interface EvaluationResultsTitleProps {
    resultsStatus?: string;
}

export const EvaluationResultsTitle: FC<EvaluationResultsTitleProps> = ({ resultsStatus }) => {
    const evaluationResultsStatus = getChallengeResults(resultsStatus);

    return (
        <Text ml="xl" m={20} fw={600} size="lg" flex="1">
            {CHALLENGE_EVALUATION_TITLE[evaluationResultsStatus]}
        </Text>
    );
};
